import { render } from "./PageBreadCrumbs.vue?vue&type=template&id=026a9e0f"
import script from "./PageBreadCrumbs.vue?vue&type=script&lang=js"
export * from "./PageBreadCrumbs.vue?vue&type=script&lang=js"

import "./PageBreadCrumbs.vue?vue&type=style&index=0&id=026a9e0f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__